import React, {Component} from 'react';
import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import {Nav, Navbar, NavItem} from "react-bootstrap";
import {Collapse, Label} from 'reactstrap';
//import Select from 'react-select';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import ReactTooltip from 'react-tooltip';
import {Link} from 'react-router-dom';
import jwt_decode from "jwt-decode";
import CommonNavbar, {navbar} from "./commonNavbar";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class PromotionMaster extends Component {
    constructor(props){
        super(props);
        this.state = {
            unmapped_files : [],
            unmappedData: {
                id: '',
                user_id: '',
                file_name: '',
                file_path: '',
                timestamp: '',
                version: '',
                cur_version: '',
                status:'',
                user_type: ''
            },
            unmappedModel: false,
            data:[],
            loading:true,
            _notificationSystem: null,
            versions:[],
            tableLists:[],
            newRelationModel: false,
            deleteKeys:[],
            user_id: null,
            map_status: null,
            stored_file_name: null,
            file_name: null,
            userGroup: null,
            id: null,
            campaign_response: [],
            emiMenus:[],
            party_master_id: null
        };
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        this.getPartyID();
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
    }

    getPartyID(){
        if ($.fn.DataTable.isDataTable('#party_showTable')) {
            $('#party_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
            }
        }).then(response => {
            //console.log(response.data);
            response.data.map((values, index) => {
                console.log(values.party_id);
                this.setState({
                    party_master_id: values.party_id
                })
            })
            this.setState({
                party_id_mapper: response.data
            });
            $('#party_showTable').DataTable();
            this.setState({
                loading: false,
                user_id: decoded._id
            });
            this._refreshCampaign();
        });
    }

    setDescription = (optionSelected) => {
        this.setState({ selectedDescription: optionSelected });
        console.log(this.state.selectedDescription)
    };
    updateSKU = (optionSelected) => {
        this.setState({ selectedSKU: optionSelected.value })
    };
    updatePrice = (optionSelected) => {
        this.setState({ selectedPrice: optionSelected.value })
    };

    toggleunmappedModel() {
        this.setState({
            unmappedModel: !this.state.unmappedModel
        })
    }

    campaignDropdown = () => {
        this.props.history.push('/admin/new-create-promotion')
    }
    
    _refreshCampaign() {
        if ($.fn.DataTable.isDataTable('#campaignTable')) {
            $('#campaignTable').DataTable().destroy();
        }

        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        //console.log(decoded);
        axios.get(config.get('API_URL') + '/brandemi/get_campaign_brand',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id
            }
            }).then(response => {
            console.log(response);
            this.setState({
                campaign_response: response.data
            });
            $('#campaignTable').DataTable({
                "oLanguage": {
                    "sEmptyTable": "You have not created any promotions"
                }
            });
            
            this.setState({
                loading: false
            })

        });
    }

    mapData(id, map_status, stored_file_name, user_type, user_id, file_name){
        this.setState({
            id: id,
            map_status: map_status,
            stored_file_name: stored_file_name,
            userGroup: user_type,
            user_id: user_id,
            file_name: file_name
        });
        this.openSectionToMap(true);
    }

    goBack = () => {
        this.props.history.push('/admin/brand-emi')
    }

    openSectionToMap = (status) => {
        console.log(this.state.userGroup);
        this.setState({
            mapField: status
        })
    };

    updateMapVisiblity = (value) => {
        console.log(JSON.stringify(value));
        this.setState({
            mapField: value
        })
    };
    
    render() {

        let menus = this.state.emiMenus.map((menu, index) =>{
            return (
                <NavItem key={index} eventKey={index + "_" + 5} componentClass={Link} href={menu.layout+menu.path } to={menu.layout+menu.path}>
                    {menu.name}
                </NavItem>
            )
        });

        let campaign_data = this.state.campaign_response.map((value,index) => {
            let Activer = 'Created';
            let edit_activer = false;
            let timer = new Date(value.start_date).toJSON().slice(0, 10).replace('T', ' ');
            let timer1 = new Date(value.end_date).toJSON().slice(0, 10).replace('T', ' ');
            let timer2 = new Date(value.record_update_timestamp);
            timer2.setHours( timer2.getHours() + 5 );
            timer2.setMinutes( timer2.getMinutes() + 30 );
            // timer
            let timer3 = timer2.toJSON().slice(0, 19).replace('T', ' ');
            if (value.active != 0 || value.active != '0')
            {   
                if (value.active == -1 || value.active == '-1'){
                    Activer = 'Rejected';
                    edit_activer=true;
                }
                else if (value.active == 2 || value.active == '2'){
                    Activer = 'Configured';
                    edit_activer=true;
                }
                else if (value.active == 3 || value.active == '3'){
                    Activer = 'QA Verified';
                    edit_activer=true;
                }
                else if (value.active == 4 || value.active == '4'){
                    Activer = 'Active';
                    edit_activer=true;
                }
                else if (value.active == 1 || value.active == '1'){
                    Activer = 'Approved';
                    edit_activer=true;
                }
                else{
                    Activer = 'Expired';
                    edit_activer=true;
                }
                
                return (
                    <tr key={index + 1}>
                        <td>{index + 1}</td>
                        <td>{value.campaign_name}</td>
                        <td>{value.campaign_desc}</td>
                        <td>{timer}</td>
                        <td>{timer1}</td>
                        <td>{timer3}</td>
                        <td>{Activer}</td>
                        <td>
                            <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                            <Link className="viewButton" data-tip="View Promotion Summary"  to={"/admin/new-view-promotion/" + value.id}><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                        </td>
                    </tr>
                );
            }
            else{
                
                return (
                    <tr key={index + 1}>
                        <td>{index + 1}</td>
                        <td>{value.campaign_name}</td>
                        <td>{value.campaign_desc}</td>
                        <td>{timer}</td>
                        <td>{timer1}</td>
                        <td>{timer3}</td>
                        <td>{Activer}</td>
                        <td>
                            <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                            <Link className="viewButton" data-tip="View Promotion Summary"  to={"/admin/new-view-promotion/" + value.id}><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                            <Link className="viewButton" disabled={edit_activer} data-tip="Edit Promotion"  to={"/admin/new-edit-promotion/" + value.id}><span className="glyphicon glyphicon-edit" aria-hidden="true"></span></Link>
                        </td>
                    </tr>
                );
            }
        });

        return(
            <div className="longcontent">
            <CommonNavbar/>
        <div className="container-fluid">
        <div className="card-query-builder">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <div className="pt-5">
                    <div className="card " ref={this.myRef}>
                        
                            <div className="header">
                                
                                    <h4 className="title pull-left">Promotions</h4>
                                    <button onClick={this.campaignDropdown} className="btn btn-primary btn-capitalize pull-right">Create New</button>
                                
                            </div>
                        
                        <div className="content">
                            <div className='sweet-loading'>
                                <BeatLoader
                                    css={override}
                                    sizeUnit={"px"}
                                    size={20}
                                    color={'#123abc'}
                                    loading={this.state.loading}
                                />
                            </div>
                            {/* <div className="col-md-12">
                                
                            </div> */}
                            <div className="table-full-width table-responsive-bemi notablerightmargin top-pad-5">
                                <table className="table table-striped table-hover" id="campaignTable">
                                    <thead>
                                    <tr>
                                        <th>Sr_No.</th>
                                        <th>Promotion Name</th>
                                        <th>Promotion Description</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th>Date Added</th>
                                        <th>Status</th>
                                        <th width="70px">Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {campaign_data}
                                    </tbody>
                                </table>
                            </div>
                            <div className="footer">
                                <div className="stats"><i></i></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            </div>
        );
    }
}


export default PromotionMaster;